<template>
  <div class="data-element-info">
    <el-form :model="queryInfo" :rules="rules" ref="BusinessInfoForm">
      <div class="data-log-info">
        <div class="data-log-info-item">
          <div class="label">数据编号：</div>

          <div class="value">NO.NWEA20250101102</div>
        </div>

        <div class="data-log-info-item">
          <div class="label">数据来源类型：</div>

          <div class="value">爬虫采集</div>
        </div>

        <div class="data-log-info-item">
          <div class="label">数据来源：</div>

          <a
            href="https://www.tianyancha.com/company/661352253"
            target="_blank"
          >
            https://www.tianyancha.com/company/661352253
          </a>
        </div>
      </div>

      <div class="table-box ly_table_light">
        <p class="info-title">数据变更&nbsp;&nbsp;1次</p>

        <el-table :data="tableData" border style="width: 870px"
        header-cell-class-name="ly_table_light_header"
        cell-class-name="ly_table_light_cell">
          <el-table-column label="序号" align="center" width="100">
          </el-table-column>

          <el-table-column label="操作人" align="center" width="140">
          </el-table-column>

          <el-table-column label="操作时间" align="center" width="160">
          </el-table-column>

          <el-table-column label="操作记录" align="center" width="315">
          </el-table-column>

          <el-table-column label="更新时间" align="center"> </el-table-column>
        </el-table>
      </div>

      <div class="paging-group">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        >
        </el-pagination>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {
      currentPage: 1,
      tableData: [],
      queryInfo: {
        bugName: "", // 爬虫名称
        bugWeb: "", // 爬虫来源
        bugTime: "", // 爬取时间
        dataIntegrity: "", // 数据完整性
        dataQuality: "" // 数据质量
      },
      rules: {}
    };
  },
  methods: {
    // 分页器
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style scoped lang="less">
.data-element-info {
  .data-log-info {
    border-bottom: 20px solid #d8efff;

    .data-log-info-item {
      display: flex;
      font-size: 16px;
      line-height: 40px;

      .label {
        width: 190px;
        text-align: right;
      }

      a {
        color: #000000;
      }
    }
  }

  .info-title {
    margin-top: 20px;
    margin-bottom: 17px;
    font-size: 18px;
    line-height: 25px;
  }

  .input-box {
    margin-top: 10px;
  }

  .table-box {
    padding-left: 100px;
    padding-bottom: 10px;
    font-weight: bold;
  }

  .paging-group {
    margin-top: 20px;
    margin-left: 190px;
    width: 870px;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    width: 190px;
    text-align: right;
    color: #000000;
  }
}
</style>
